import { Enum } from "@teaming/common-enums";

export default Enum.create( {
	CREATE_TEAMING_GLOBAL: "CREATE_TEAMING_GLOBAL",
	DISABLE_VUEX_LOGGING: "DISABLE_VUEX_LOGGING",
	DISC_CRYSTAL_TEAMING: "DISC_CRYSTAL_TEAMING",
	LOGGED_IN: "loggedIn",
	REDIRECT_TO_URL: "REDIRECT_TO_URL",
	REDIRECT_TO_TARGET: "REDIRECT_TO_TARGET",
	TEAMING_CONFIG: "TEAMING_CONFIG",
	/** @deprecated */
	TRANSCRIPTION_STATUS_MASKS: "TRANSCRIPTION_STATUS_MASKS",
	TEAM_STREAM_SIDEBAR_STATE: "TEAM_STREAM_SIDEBAR_STATE",
} );
